export enum COMMON_STEPS {
  SUBMIT = 'SUBMIT',
}
